import { httpClient } from '@/services/http/httpClient'

export async function deletePortfolio(id: string) {
  await httpClient.delete(`/projects/portfolios/${id}`)
}
